import { render, staticRenderFns } from "./MspEditAllenamento.vue?vue&type=template&id=4cca93e8"
import script from "./MspEditAllenamento.vue?vue&type=script&lang=js"
export * from "./MspEditAllenamento.vue?vue&type=script&lang=js"
import style0 from "./MspEditAllenamento.vue?vue&type=style&index=0&id=4cca93e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports